import axios from "axios";
import apiConfig from "../config/api.js";

const API_URL = apiConfig.baseURL;

const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Service pour gérer la liste de courses de l'utilisateur
 */
const shoppingListService = {
  /**
   * Récupérer la liste active (créée automatiquement côté serveur si absente)
   */
  getActiveList: async () => {
    const response = await axios.get(`${API_URL}/shopping-list`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  /**
   * Ajouter un article
   * @param {{section: string, name: string, quantity?: string, calories?: number}} item
   */
  addItem: async (item) => {
    const response = await axios.post(`${API_URL}/shopping-list/items`, item, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  /**
   * Mettre à jour un article (ex: { is_checked: true })
   */
  updateItem: async (itemId, fields) => {
    const response = await axios.patch(
      `${API_URL}/shopping-list/items/${itemId}`,
      fields,
      { headers: getAuthHeader() },
    );
    return response.data;
  },

  /**
   * Supprimer un article
   */
  deleteItem: async (itemId) => {
    const response = await axios.delete(
      `${API_URL}/shopping-list/items/${itemId}`,
      { headers: getAuthHeader() },
    );
    return response.data;
  },

  /**
   * Archiver la liste active (elle passe dans l'historique, une nouvelle liste vide est créée)
   */
  archiveActiveList: async () => {
    const response = await axios.post(
      `${API_URL}/shopping-list/archive`,
      {},
      { headers: getAuthHeader() },
    );
    return response.data;
  },

  /**
   * Récupérer l'historique des listes archivées
   */
  getHistory: async () => {
    const response = await axios.get(`${API_URL}/shopping-list/history`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },
};

export default shoppingListService;
